// Polyfills
import "./lib/polyfills/focus-within.js";

// Grid Settings
import grid from "../scss/helpers/_grid-settings.scss";

// Extentions
import "./components/extensions/jquery.accordion.js";
import "./components/extensions/jquery.expandingSchedule.js";
import "./components/extensions/jquery.focusable.js";
import "./components/extensions/jquery.menuToggle.js";
import "./components/extensions/jquery.modal.js";
import "./components/extensions/jquery.notification.js";

// Components
import "./components/animate-image-on-link-hover.js";
import "./components/on-load.js";
import "./components/layout/carousel.js";

import "./components/layout/hero-slider.js";
import "./components/layout/teacher-images.js";
import "./components/layout/footer.js";
import "./components/layout/full-width-components.js";
import "./components/layout/main-nav.js";
import "./components/layout/sub-hero.js";
import "./components/layout/gallery.js";
import "./components/layout/footer.js";
import "./components/layout/search-box.js";
import "./components/layout/sidebar.js";
import "./components/layout/hero-slider.js";
import "./components/layout/snapchat.js";
import "./components/layout/tabs.js";
import "./components/layout/video-list.js";
import "./components/layout/deadlines.js";
import "./components/animate-image-on-link-hover.js";
import "./components/template/search.js";
import "./components/layout/featured-courses-carousel.js";
import "./components/layout/testimonials.js";

export { grid };



// WEBPACK FOOTER //
// ./assets/js/script.js